import { put } from 'redux-saga/effects';
import { takeLatest } from '@redux-saga/core/effects';
import { notification } from 'antd';
import i18n, { languageKeys } from 'i18n';
import { doCancelPayment, doFetchSupplyList, doSavePayment, setLoadingSell, updateSupplyList } from 'ducks/slices/QlyVienPhi/BanThuoc.slice';
import { setFormLoading } from 'ducks/slices/loadingSlice';
import { common_post } from 'helpers';
import { apis } from "../../../constants";


export function* watchDoBanThuoc() {
  yield takeLatest(doFetchSupplyList, handleFetchSupplyList);
  yield takeLatest(doSavePayment, handleSavePayment);
  yield takeLatest(doCancelPayment, handleDoCancelPayment);
}


function* handleFetchSupplyList({ payload }) {
  try {
    yield put(setFormLoading(true));
    const res = yield common_post(apis.layChiTietPhieuBanVatTuThanhToanBenCis, {
      LICH_KHAM_ID: payload.LICH_KHAM_ID,
    })
    if (res) {
      if (res.status === 'OK') {
        yield put(updateSupplyList(res.result))
      } else {
        notification.error({
          message: i18n.t(languageKeys.noti_Tai_du_lieu_that_bai),
          placement: 'bottomLeft'
        });
      }
    } else {
      notification.error({
        message: i18n.t(languageKeys.noti_Tai_du_lieu_that_bai),
        placement: 'bottomLeft'
      });
    }
  } catch (err) {
    notification.error({
      message: i18n.t(languageKeys.common_co_loi_xay_ra),
      placement: 'bottomLeft'
    });
    if (err instanceof Error) {
      console.log(err.message);
    }
  } finally {
    yield put(setFormLoading(false));
  }
}


function* handleSavePayment(action) {
  // Data
  const { dataR, dataP, afterSuccess } = action.payload;
  try {
    yield put(setLoadingSell(true));
    // Duyệt
    const resR = yield common_post(apis.duyetPhieuBanVatTu, dataR)
    if (resR) {
      if (resR.status === "KO") {
        if (resR.error_code === "014") {
          notification.error({
            message: i18n.t(languageKeys.duoc_khong_du_so_luong),
            placement: "bottomLeft"
          });
        } else {
          notification.error({
            message: i18n.t(languageKeys.thao_tac_that_bai),
            placement: 'bottomLeft'
          });
        }
        return;
      }
    } else {
      notification.error({
        message: i18n.t(languageKeys.thao_tac_that_bai),
        placement: 'bottomLeft'
      });
      return;
    }
    // Thanh toán
    const resP = yield common_post(apis.thanhToanPhieuVatTu, dataP)
    if (resP) {
      if (resP.status === 'OK') {
        notification.success({
          message: i18n.t(languageKeys.thao_tac_thanh_cong),
          placement: 'bottomLeft'
        });
        afterSuccess()
      } else {
        if (resP.status === "KO" && resP.error_code === "014") {
          notification.error({
            message: i18n.t(languageKeys.duoc_khong_du_so_luong),
            placement: "bottomLeft"
          });
        } else {
          notification.error({
            message: i18n.t(languageKeys.thao_tac_that_bai),
            placement: 'bottomLeft'
          });
        }
      }
    } else {
      notification.error({
        message: i18n.t(languageKeys.thao_tac_that_bai),
        placement: 'bottomLeft'
      });
    }
    // Lỗi
  } catch (err) {
    notification.error({
      message: i18n.t(languageKeys.common_co_loi_xay_ra),
      placement: 'bottomLeft'
    });
    if (err instanceof Error) {
      console.log(err.message);
    }
  } finally {
    yield put(setLoadingSell(false));
  }
}


function* handleDoCancelPayment(action) {
  const { data, setLoading, closeModal } = action.payload;
  try {
    setLoading(true);
    const res = yield common_post(apis.huyThanhToan, data)
    if (res) {
      if (res.status === 'OK') {
        closeModal()
        notification.success({
          message: i18n.t(languageKeys.huy_phieu_thanh_cong),
          placement: 'bottomLeft'
        });
      } else {
        notification.error({
          message: i18n.t(languageKeys.thao_tac_that_bai),
          placement: 'bottomLeft'
        });
      }
    } else {
      notification.error({
        message: i18n.t(languageKeys.thao_tac_that_bai),
        placement: 'bottomLeft'
      });
    }
  } catch (err) {
    notification.error({
      message: i18n.t(languageKeys.thao_tac_that_bai),
      placement: 'bottomLeft'
    });
    if (err instanceof Error) {
      console.log(err.message);
    }
  } finally {
    setLoading(false);
  }
}